<div class="order-type">
	@if (visibleLabel()) {
		<div class="complex">
			<label class="label">{{ 'orderTypes.label' | translate }}</label>

			<app-select
				[control]="control()"
				[items]="types()"
				translationPrefix="orderTypes"
			/>
		</div>
	} @else {
		<div class="simple">
			<app-select
				[control]="control()"
				[items]="types()"
				translationPrefix="orderTypes"
			/>
		</div>
	}
</div>
